import { useUser } from "../context/UserContext";

const IsAdmin = ({ children }) => {
  const { isAdmin } = useUser();
  return <>{isAdmin && children}</>;
};

export default IsAdmin;
